var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRingBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7756 15.3195C36.7756 7.39512 28.7585 1 18.8878 1C9.01707 1 1 7.39512 1 15.3195C1 23.2439 9.01707 29.639 18.8878 29.639C20.4171 29.639 21.9463 29.5 23.3829 29.1756L31.3073 34.3659V25.6537C34.6902 23.0122 36.7756 19.3976 36.7756 15.3195Z",
    stroke: "#574BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8537 14.9271C13.8537 15.4368 13.4366 15.8539 12.9268 15.8539C12.4171 15.8539 12 15.4368 12 14.9271C12 14.4173 12.4171 14.0002 12.9268 14.0002C13.4366 14.0466 13.8537 14.4173 13.8537 14.9271Z",
    stroke: "#574BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7854 14.9268C19.7854 15.4366 19.3683 15.8537 18.8586 15.8537C18.3488 15.8537 17.9318 15.4366 17.9318 14.9268C17.9318 14.4171 18.3488 14 18.8586 14C19.3683 14.0463 19.7854 14.4171 19.7854 14.9268Z",
    stroke: "#574BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7171 14.9268C25.7171 15.4366 25.3 15.8537 24.7902 15.8537C24.2805 15.8537 23.8634 15.4366 23.8634 14.9268C23.8634 14.4171 24.2805 14 24.7902 14C25.3 14.0463 25.7171 14.4171 25.7171 14.9268Z",
    stroke: "#574BCE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingBox);
export default __webpack_public_path__ + "static/media/ring-box.26063ebe.svg";
export { ForwardRef as ReactComponent };